<template>
  <div class="mr-2">
    <input id="feature-product-image" type="hidden" @change="onFileChange"/>

    <div class="my-2 mx-auto text-center">
      <img alt="" class="feature-checkbox-image"
           :src="setFeatureImage"/>
    </div>

    <b-form-file
        browse-text="انتخاب عکس"
        @change="onFileChange"
        class="text-center"
        v-model="currentFeatureProduct.featureImage"
        placeholder="انتخاب عکس"
        drop-placeholder="انتخاب عکس"
    ></b-form-file>
  </div>
</template>

<script>
import {defaultProductImage} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "CheckboxItemImage",
  props: {
    attribute: {},
    product: {},
  },
  data() {
    return {
      defaultProductImage
    }
  },
  computed: {
    setFeatureImage() {
      let preview = this.currentFeatureProduct.preview
      let featureImage = this.currentFeatureProduct.image;
      let defaultImage = this.defaultProductImage

      if (preview != null) {
        return preview
      }

      if (featureImage == null) {
        return defaultImage
      }
      return featureImage
    },
    currentFeatureProduct() {
      // find item inside product features.
      let result = {}
      this.product.features.forEach(item => {
        if (item.feature_attribute_id == this.attribute.id) {
          result = item
        }
      })
      return result
    }
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.currentFeatureProduct.image = file;
      this.currentFeatureProduct.preview = URL.createObjectURL(file);
    },
  }
}
</script>

<style scoped>
.feature-checkbox-image {
  width: 100px;
  height: 100px;
  object-fit: contain;
}
</style>